import Vue from 'vue';
import Vuex from 'vuex';
import {VueRouter} from "vue-router/types/router";
import {ProgramPaths} from "@/enum/ProgramPaths";
import {PersonelEntity} from "@/entity/PersonelEntity";
import gorevYoneticisi from "@/plugins/uyap-plugin/store/modules/GorevYoneticisi";
import takipDetay from "@/store/modules/takipDetay";
import takipEkle from "@/store/modules/takipEkle";
import theme from "@/store/modules/theme";
import app from "@/main";
import {AppState} from "@/types";
import VueSocketIOExt from 'vue-socket.io-extended';
import {io} from 'socket.io-client';
import takipHazirla from '@/store/modules/formWizards/takipHazirla';
import mtsTakipHazirla from '@/store/modules/formWizards/mtsTakipHazirla';
import {KullaniciBilgileriCevap} from "@/plugins/uyap-plugin/uyap/KullaniciBilgileri";
import {sortMahkemelerByIsimAsc} from "@/utils/mahkemeSort";

// İmza websocket
const socket = io('https://imza.eicrapro.com:3000', {
    autoConnect: true,
    reconnection: true
});
Vue.use(VueSocketIOExt, socket);
Vue.use(Vuex);
export const store = new Vuex.Store({
    modules: {
        // @ts-ignore
        gorevYoneticisi,
        takipDetay,
        takipEkle,
        theme,
        takipHazirla,
        mtsTakipHazirla
    },
    state: <AppState>{
        accessToken: localStorage.getItem('accessToken'),
        tenant_id: sessionStorage.getItem('tenantId'),
        user: <PersonelEntity>JSON.parse(sessionStorage.getItem('user') ?? "{}"),
        activeProcesses: JSON.parse(sessionStorage.getItem("activeProcesses") ?? "[]"),
        createTcKimlikErrors: [],
        icraProTakipBilgileri : {},
        xml: null,
        eicraproDevMode: false,  // Mock data kullanmak için true yap
        imzaConnection: false,
        uyapConnection: false,
        ssoConfig: null,
        uyapAvukatBilgileri: undefined,
        uyapSorguBakiye: undefined,     // Sorgu bakiyesi
        uyapAvukatBakiye: undefined,    // E-Barobirlik bakiyesi
        avukatlar: [],
        mahkemeler:[],
        noterler:[],
        tenantList: [],
        kurlar: [],
        personeller: [],
        cardList: [],
        tenantListPromise: null,
        imzaConnIntervalId: null,
        ssoUri: process.env.VUE_APP_SSO_TARGET,
        programs: [
            {
                name: "Ofispro",
                programPath: ProgramPaths.ofispro,
                urls: [
                    "ofispro.com",
                    "test.ofispro.com",
                    "ofispro.lcl",
                    "localhost",
                ],
            },
            {
                name: "IcraproWeb",
                programPath: ProgramPaths.icrapro,
                urls: [
                    "icrapro.com",
                    "test.icrapro.com",
                    "cloudbeta.zirve-bilgisayar.com",
                    "cloudopt.zirve-bilgisayar.com",
                    "cloudtest.zirve-bilgisayar.com",
                    "cloudtest1.zirve-bilgisayar.com",
                    "cloudtest2.zirve-bilgisayar.com",
                    "cloudtest3.zirve-bilgisayar.com",
                    "cloudtest4.zirve-bilgisayar.com",
                    "cloudicra.neova.com.tr",
                    "okandemirkan.icrapro.com",
                    "cloud.zirve-bilgisayar.com",
                    "icrapro.lcl",
                ]
            },
            {
                name: "e-İcrapro",
                programPath: ProgramPaths.eicrapro,
                urls: [
                    "eicrapro.com",
                    "test.eicrapro.com",
                    "eicrapro.lcl",
                ]
            }
        ]
    },
    actions: {
        async fetchIcraProTakipBilgileri({ commit, state }, id) {
            try {
                const response = await Vue.prototype.$http.get(`/api/v1/takip/${id}`);
                commit('setIcraProTakipBilgileri', response.data);
            } catch (error) {
                console.error('Takip bilgileri alınırken hata oluştu:', error);
            }

        },
        connectToImza({commit}) {
            app.$imza.heartbeat().then(() => {
                commit('setImzaConnection', true);
                app.$toast.success('İmzacı bağlantısı tamamlandı.');
            }).catch((error: any) => {
                commit('setImzaConnection', false);
                app.$toast.error('İmzacı bağlantısı yapılamadı. (' + error + ')');
            });
        },
        startImzaConnInterval({state, commit, dispatch}) {
            if (!state.imzaConnection) {
                const intervalID = setInterval(() => {
                    dispatch('checkUyapSession');
                }, 30000);
                commit('setImzaConnIntervalId', intervalID);
            }
        },
        stopImzaConnInterval({state, commit}) {
            if (state.imzaConnIntervalId) {
                clearInterval(state.imzaConnIntervalId);
                commit('setImzaConnIntervalId', null);
            }
        },
        async checkUyapSession({state, commit, dispatch}) {
            console.log("Check Uyap Session triggered");
            try {
                if (state.eicraproDevMode) {
                    commit('setImzaConnection', true);
                    commit('setUyapConnection', true);
                } else {
                    await app.$imza.heartbeat();
                    let cardList = await app.$imza.availableCards();
                    commit('setCardList',cardList);
                    if(cardList.length == 0)
                        return;
                    await app.$imza.setApiCookiesToImza();
                    console.log("SETTEd COOKIES TO IMZA");
                    await app.$uyap.KullaniciBilgileri().run({});
                    console.log("KullaniciBilgileri runned");
                    app.$socket.client.emit('updateTasks');
                    //TODO Task update i sadece socket uzerinden olmali socket de sadece diger clientlara gonderiyor sorun var. duzeltilip dispatch kalirilacak.
                    await store.dispatch('updateTasks');
                    commit('setImzaConnection', true);
                    commit('setUyapConnection', true);
                }
            } catch (error) {
                console.log("checkUyapSession error",error)
                commit('setImzaConnection', false);
                commit('setUyapConnection', false);
            }
        },
        async getKurlarMerkezBankasi({ state, commit }) {
            try {
                if (state.kurlar.length > 0)
                    return state.kurlar;
                let response = await Vue.prototype.$http.get("https://www.icrapro.com/todaykur.php");
                commit('setKurlar', response);
            } catch (e) {
                throw e;
            }
        },
        async getTenantList({ state, commit }) {
            try {
                console.log("getTenantList TRIGGERED");

                // 1) Eğer data zaten varsa direkt dön
                if (state.tenantList.length > 0) {
                    return state.tenantList;
                }

                // 2) Eğer istek devam ediyorsa onu beklet
                if (state.tenantListPromise) {
                    return await state.tenantListPromise;
                }

                // 3) Yeni bir promise yarat
                const promise = Vue.prototype.$http
                    .get("/api/v1/oauth/user-tenant-list")
                    .then(res => {
                        const list = Array.isArray(res?.data) ? res.data : (Array.isArray(res) ? res : []);
                        commit('setTenantList', list);
                        return list;
                    })
                    .finally(() => {
                        commit('setTenantListPromise', null);
                    });

                // Promise’i state’e kaydet
                commit('setTenantListPromise', promise);

                // İlk çağıran bunu bekler
                return await promise;

            } catch (e) {
                commit('setTenantListPromise', null);
                throw e;
            }
        },
        async getSelectedTenantId({state, commit}) {
            return sessionStorage.getItem("tenantId");
        },
        async getUser({state, commit}) {
            if (!state.user.id) {
                let response = await Vue.prototype.$http.get("/api/v1/ben");
                commit('setUser', response.data);
            }
            return state.user;
        },
        async getAvukatlar({state, commit}) {
            if (state.avukatlar.length == 0) {
                let response = await app.$http.get("/api/v1/personel/filter?type=avukat");
                commit('setAvukatlar', response.data);
            }
            return state.avukatlar;
        },
        async getMahkemeler({state, commit}) {
            if (state.mahkemeler.length == 0) {
                let response = await app.$http.get('/api/v1/mahkeme/');
                commit('setMahkemeler', response.data);
            }
            return state.mahkemeler;
        },
        async getNoterler({state, commit}) {
            if (state.noterler.length == 0) {
                let response = await app.$http.get('/api/v1/noter/');
                commit('setNoterler', response.data);
            }
            return state.noterler;
        },
        async getPersoneller({state, commit}) {
            if (state.personeller.length == 0) {
                let response = await app.$http.get("/api/v1/personel");
                commit('setPersoneller', response.data)
            }
            return state.personeller;
        },
        async loginWithSso({state, commit}) {
            Vue.prototype.$http.get('/api/v1/oauth/login').then((res: any) => {
                location.href = res.data;
            })
        },
        async tenantData({state,dispatch}){
            return new Promise(async (resolve, reject)=>{
                await dispatch('getTenantList');
                resolve(state.tenantList.find(item => item.tenant_id == state.tenant_id));
            });
        }
    },
    mutations: {
        setIcraProTakipBilgileri(state, data) {
            state.icraProTakipBilgileri = data;
        },
        setRouter(state: AppState, router: VueRouter) {
            state.router = router;
        },
        setCardList(state: AppState, cardList: any[]) {
            state.cardList = cardList;
        },
        setUser(state: AppState, user: PersonelEntity) {
            state.user = user;
            sessionStorage.setItem("user", JSON.stringify(user));
        },
        setTenantId(state: AppState, tenantId: string) {
            sessionStorage.setItem("tenantId", tenantId);
            let tenant = state.tenantList.find(tenant=>tenant.tenant_id == tenantId);
            if(tenant)
                sessionStorage.setItem("selectedTenant", JSON.stringify(tenant));
            state.tenant_id = tenantId;
        },
        setAccessToken(state: AppState, accessToken: string) {
            state.accessToken = accessToken;
            localStorage.setItem("accessToken", accessToken);
        },
        setActiveProcess(state: AppState, activeProcess: any) {
            if (activeProcess.isRoot) {
                state.activeProcesses = [];
            }
            state.activeProcesses.push(activeProcess);
            sessionStorage.setItem("activeProcesses", JSON.stringify(state.activeProcesses))
        },
        setImzaConnection(state: AppState, connection: boolean) {
            state.imzaConnection = connection;
        },
        setUyapConnection(state: AppState, payload: boolean) {
            state.uyapConnection = payload;
        },
        setUyapAvukatBilgileri(state: AppState, avukat: KullaniciBilgileriCevap) {
            state.uyapAvukatBilgileri = avukat;
        },
        setUyapAvukatBakiye(state: AppState, bakiye: string) {
            state.uyapAvukatBakiye = bakiye;
        },
        setUyapSorguBakiye(state: AppState, bakiye: string) {
            state.uyapSorguBakiye = bakiye;
        },
        setAvukatlar(state: AppState, data) {
            state.avukatlar = data;
        },
        setMahkemeler(state: AppState, data) {
            const sorted = Array.isArray(data) ? sortMahkemelerByIsimAsc(data) : [];
            state.mahkemeler.splice(0, state.mahkemeler.length, ...sorted);
        },
        resortMahkemeler(state: AppState) {
            const sorted = sortMahkemelerByIsimAsc(state.mahkemeler);
            state.mahkemeler.splice(0, state.mahkemeler.length, ...sorted);
        },
        setNoterler(state: AppState, data) {
            state.noterler = data;
        },
        setTenantList(state: AppState, data) {
            state.tenantList = data;
        },
        setKurlar(state: AppState, data) {
            state.kurlar = data;
        },
        setTenantListPromise(state: AppState, promise) {
            state.tenantListPromise = promise;
        },
        setPersoneller(state: AppState, data) {
            state.personeller = data;
        },
        setImzaConnIntervalId(state: AppState, intervalId) {
            state.imzaConnIntervalId = intervalId;
        }
    },
    getters: {
        router: (state: AppState) => state.router,
        accessToken: (state: AppState) => state.accessToken,
        isDev: (state: AppState) => !window.location.hostname.includes('.com'),
        isEicraPro: (state: AppState) => window.location.pathname.startsWith(ProgramPaths.eicrapro),
        isIcraPro: (state: AppState) => window.location.pathname.startsWith(ProgramPaths.icrapro),
        isOfisPro: (state: AppState) => window.location.pathname.startsWith(ProgramPaths.ofispro),
        isDavaPro: (state: AppState) => window.location.pathname.startsWith(ProgramPaths.davapro),
        isArabulucuPro: (state: AppState) => window.location.pathname.startsWith(ProgramPaths.arabulucupro),
        isImzaConnected: (state: AppState) => state.imzaConnection,
        isUyapConnected: (state: AppState) => state.uyapConnection,
        home: (state: AppState) => ProgramPaths.ofispro,
        isEicraproDevMode: (state: AppState) => state.eicraproDevMode,
        avukatBilgileri: (state: AppState) => state.uyapAvukatBilgileri,
        avukatBakiye: (state: AppState) => state.uyapAvukatBakiye,
        sorguBakiye: (state: AppState) => state.uyapSorguBakiye,
        ssoConfig: (state: AppState) => state.ssoConfig,
        userData: (state: AppState) => state.user,
        licenses: (state: AppState) => state.user.licenses.filter(licence => licence.tenant_id == state.tenant_id),
        tenant: (state: AppState) => state.tenantList.find(item => item.tenant_id == state.tenant_id)
    }
});
